import { Day, VerifiedSiteLocation } from './types';

export enum SessionEnrollmentStatus {
  NotFull = 0,
  Waitlist = 1,
  Full = 2,
  Ended = 3,
}

export enum SessionBillingCycle {
  OneTime = 0,
  Weekly = 1,
  Monthly = 2
}

export interface CatalogSession {
  programName: string;
  programId: number;
  sessionName: string;
  sessionId: number;
  note1: string;
  note2: string;
  startDateTime: string;
  endDateTime: string;
  isTimeAdded: boolean;
  selectedDays: Array<Day>;
  ageTo?: number;
  ageFrom?: number;
  ageAsOf?: string;
  // number of scholars currently on the session waitlist
  waitlistCount: number;
  // maximum number of scholars on the session waitlist; if undefined, indicates zero capacity
  waitlistCapacity?: number;
  // number of scholars currently enrolled in the session
  enrollmentCount: number;
  // maximum number of scholars enrolled in the session; if undefined, indicates unlimited capacity
  scholarCapacity?: number;
  price: number;
  priceId: string;
  sessionBillingCycle: SessionBillingCycle;
  billingCycleCount: number;
  siteLocationId?: number;
  siteLocation?: VerifiedSiteLocation;
  sessionEnrollmentStatus: SessionEnrollmentStatus;
  taxRateId?: string;
  taxRatePercentage: number;
  waitListIsUnlimited?: boolean | null;
}

export interface CatalogSessionList {
  totalSetCount: number;
  count: number;
  results: Array<CatalogSession>;
}

export interface CatalogSessionFilters {
  accountId: number;
  sessions: Array<SessionFilterParameters>;
}

export interface SessionFilterParameters {
  sessionId: number;
  programId: number;
  programName: string;
  siteLocationId: number | null;
  siteLocationName: string | null;
  startDate: Date;
  endDate: Date;
}

export interface CatalogSessionListRequest {
  accountId: number;
  sessionIdList: Array<number>;
  page: number;
  count: number;
}

export interface FilterListItem {
  id: number;
  name: string;
  sessionIds: Array<number>;
}

export interface FilterListChangeData {
  checkedItem: FilterListItem;
  isAdded: boolean;
}
